import { BRAND_COLORS, COLORS_BASIC, FUNCTIONAL_COLORS } from '../../dsm/color';
import { backgroundColor, borderColor, brandColor, palette, textColor } from '../../dsm/color-token';
export const givingOldProductColorToken = {
  'product-color': '#E51B00',
  'product-color-light-100': '',
  'product-color-light-200': '',
  'product-color-light-300': '#FBDAD6',
  'product-color-light-400': '#FDE3E6',
  'product-color-dark-100': '#CC1800',
  'product-color-dark-200': '#BA1309',
  'product-color-dark-300': '#730F00',
  'product-color-dark-400': ''
};
const componentsColor = {
  'color-charts-primary': palette['palette-blue-dark-300'],
  'color-charts-secondary': palette['palette-gold']
};
export const givingOldColor = {
  COLORS_BASIC,
  COLORS: { ...BRAND_COLORS,
    ...FUNCTIONAL_COLORS
  },
  colors: { ...givingOldProductColorToken,
    ...palette,
    ...backgroundColor,
    ...textColor,
    ...borderColor,
    ...componentsColor,
    ...brandColor
  }
};